import { Box, Paper } from "@mui/material";
import { ReactNode } from "react";
import { PagePaperPreambleContainer } from "pages/Layouts/components/PagePaperPreamble";

export const FullPagePaperLayout = ({ children }: { children: ReactNode }) => {
  return (
    <>
      <PagePaperPreambleContainer />
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "minmax(0, 1fr)",
          gridTemplateRows: "1fr",
          flexGrow: 1,
          minWidth: 0,
          minHeight: "200px",
        }}
        mt={1}
      >
        <Paper
          variant="outlined"
          sx={{
            flexGrow: 1,
            minWidth: 0,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            minHeight: 0,
            "& > .MuiDataGrid-root": {
              border: "none",
            },
          }}
        >
          {children}
        </Paper>
      </Box>
    </>
  );
};
